import React from 'react';
import { ArrowRight as ArrowRightIcon, Play as PlayIcon } from '@phosphor-icons/react';
import { Section, SectionTitle } from '../Section';
import { pillar, clinicians } from '../../data/proposal';
const frameStyles = ['lg:col-span-7 lg:-rotate-[0.8deg]', 'lg:col-span-5 lg:rotate-[1.2deg] lg:translate-y-3', 'lg:col-span-5 lg:rotate-[0.9deg] lg:-translate-y-3', 'lg:col-span-7 lg:-rotate-[0.7deg]'];
export function PillarSection() {
  return <Section id="pillar" index="04" label="The pillar teaser" className="bg-white/[0.02]" fill data-id="element-220" data-mp="1apx5y942u30e">
      <div className="grid gap-5 lg:grid-cols-[1fr_1fr] lg:items-end lg:gap-14" data-id="element-221" data-mp="16obmu60y8shr">
        <div data-id="element-222" data-mp="11ps0i4ig1eov">
          <SectionTitle data-id="element-223" data-mp="11tfvl83je95p">
            One pillar Teaser
            <br data-id="element-224" data-mp="wt1njq1xqz7o" />
            above the whole series.
          </SectionTitle>
          <p className="mt-4 inline-flex items-center gap-2 rounded-full border border-primary/50 bg-primary/10 px-3 py-1.5 font-body text-xs uppercase tracking-[0.16em] text-primary" data-id="element-225" data-mp="3mhaivnygr4lc">
            <PlayIcon size={13} weight="fill" aria-hidden="true" data-id="element-226" data-mp="9qovw2g034e9" />
            Chairside by Filtek · Pillar trailer
          </p>
        </div>
        <div data-id="element-227" data-mp="dr8qay96vtwp">
          <p className="font-heading text-2xl leading-tight text-primary lg:text-[2rem]" data-id="element-228" data-mp="drqnpy7l8e67">
            How did they do that?
            <span className="text-white" data-id="element-229" data-mp="3w09ckz26aned"> Could I do that?</span>
          </p>
          <p className="mt-3 max-w-xl font-body text-sm leading-relaxed text-white/65 lg:text-base" data-id="element-230" data-mp="4q0y8xx9npb2">
            {pillar.concept} — {pillar.positioning} The pillar sells the repository first, so every
            clinician Teaser lands inside a bigger idea.
          </p>
        </div>
      </div>

      <ol className="mt-6 grid min-h-0 flex-1 grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-12 lg:grid-rows-2 lg:gap-5" data-id="element-231" data-mp="3d8ypkszkiurr">
        {pillar.frames.map((frame, i) => <li key={frame.id} className={`min-h-0 ${frameStyles[i]}`} data-id="element-232" data-mp="338y2cvykvuia" data-mpi={i}>
            <figure className="group relative h-full min-h-[130px] overflow-hidden rounded-xl border border-white/12 bg-[#02241e] shadow-[0_26px_60px_-36px_rgba(0,0,0,1)] transition-transform duration-500 hover:!rotate-0 hover:-translate-y-1" data-id="element-233" data-mp="388awm1rs43uw">
              <img src={frame.image} alt={frame.caption} className="h-full w-full object-cover" data-id="element-234" data-mp="2kc7bij2dq3w6" />
              <figcaption className="absolute inset-x-0 bottom-0 flex flex-wrap items-center gap-2.5 bg-gradient-to-t from-[#01332b] via-[#01332b]/85 to-transparent px-4 pb-3 pt-12" data-id="element-235" data-mp="2af1mdgdbsmyl">
                <span className="rounded-full border border-primary/50 bg-background/70 px-2.5 py-1 font-body text-[11px] uppercase tracking-[0.16em] text-primary" data-id="element-236" data-mp="3807a255xmylb">
                  {String(i + 1).padStart(2, '0')} · {pillar.screens[i].title}
                </span>
                <span className="font-heading text-base text-white lg:text-lg" data-id="element-237" data-mp="2t4rc3p28eijn">
                  {frame.caption}
                </span>
              </figcaption>
            </figure>
          </li>)}
      </ol>

      <div className="mt-5 flex flex-wrap items-center gap-3 rounded-xl border border-white/10 bg-white/[0.03] px-5 py-3" data-id="element-238" data-mp="1hs8hclswl1is">
        <span className="rounded-full border border-primary/50 bg-primary/10 px-3 py-1 font-body text-[11px] uppercase tracking-[0.16em] text-primary" data-id="element-239" data-mp="26wr58fc5cdp">
          Pillar
        </span>
        <ArrowRightIcon size={15} className="text-primary" aria-hidden="true" data-id="element-240" data-mp="74g321ok9d2h" />
        <ul className="flex flex-wrap items-center gap-3" data-id="element-241" data-mp="byall1sfjlzz">
          {clinicians.map(clinician => <li key={clinician.id} className="flex items-center gap-2" data-id="element-242" data-mp="gy5ch5c7gbl1">
              <img src={clinician.portrait} alt="" className="h-8 w-8 rounded-full object-cover object-[50%_20%]" data-id="element-243" data-mp="kwcqhsfaaysj" />
              <span className="font-body text-sm text-white/75" data-id="element-244" data-mp="uw3ow56ytxxw">{clinician.name}</span>
            </li>)}
        </ul>
        <ArrowRightIcon size={15} className="text-primary" aria-hidden="true" data-id="element-245" data-mp="2rpopt1v0kt9e" />
        <span className="font-heading text-base text-white" data-id="element-246" data-mp="2wo9noumsn0uo">{pillar.concept}</span>
      </div>
    </Section>;
}